import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ProofStrip } from "@/components/ProofStrip";
import { ReviewCovers } from "@/components/ReviewCovers";
import { HowItWorks } from "@/components/HowItWorks";
import { SwitchingSupport } from "@/components/SwitchingSupport";
import { AIAssistant } from "@/components/AIAssistant";
import { SavingsCalculator } from "@/components/calculator/SavingsCalculator";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { StickyCTA } from "@/components/StickyCTA";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { scrollToForm } from "@/config";
import { getAttribution } from "@/lib/analytics";

function Landing() {
  const [volume, setVolume] = useState(100000);
  const [expense, setExpense] = useState(4000);

  useEffect(() => {
    getAttribution();
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-void font-body text-white">
      <Navbar />
      <main>
        <Hero />
        <ProofStrip />
        <ReviewCovers />
        <HowItWorks />
        <SwitchingSupport />
        <AIAssistant onBook={scrollToForm} />
        <SavingsCalculator
          onBook={scrollToForm}
          volume={volume}
          expense={expense}
          onVolumeChange={setVolume}
          onExpenseChange={setExpense}
        />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
